<app-logo></app-logo>

<div *ngIf="policyList.length > 1"
     class="page-header">
    {{'IOFFER.POLICY.TITLE_MULTIPLE' | translate : {numbers: policyNumber} }}
</div>
<div *ngIf="policyList.length === 1"
     class="page-header">
    {{'IOFFER.POLICY.TITLE' | translate : {number: policyList[0].number} }}
</div>

<app-output [label]="'CONTRACT_DATE_PLACE' | translate">
    {{ policyList[0].issueDate | lsnDate }}, {{ policyList[0].additionalData.location }}
</app-output>


<app-clients-summary-box [document]="policyList[0]"
                         [readonly]="true">
</app-clients-summary-box>


<ng-container *ngFor="let policy of policyList">

    <div class="separator"></div>


    <app-property-summary-box *ngIf="policy.type === configurationType.PROPERTY"
                              [iOffer]="true"
                              [previewEnabled]="false"
                              [document]="policy"
                              [type]="summaryType.POLICY"
                              [readonly]="true">
    </app-property-summary-box>


    <app-motor-summary-box *ngIf="policy.type === configurationType.MOTOR"
                           [iOffer]="true"
                           [previewEnabled]="false"
                           [document]="policy"
                           [type]="summaryType.POLICY"
                           [readonly]="true">
    </app-motor-summary-box>
</ng-container>

<app-clauses [offer]="policyList[0]"
             [readonly]="true">
</app-clauses>
